import { screenSizeDetection as H, clickAnywhereHandler as p } from "@sunrise/shared";
import { Components as i } from "@sunrise/types";
import { defineComponent as b, ref as y, computed as l, onMounted as E, getCurrentInstance as I, watch as L } from "vue";
const r = -1, g = b({
  name: "CsTooltip",
  props: {
    position: {
      type: String,
      default: i.CsTooltip.TooltipPosition.Top
    },
    showOnHover: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["tooltipOpen", "tooltipClose"],
  setup(o, { emit: n }) {
    const { isScreenM: a } = H(), t = y(!1);
    let e;
    const T = l(() => o.position === i.CsTooltip.TooltipPosition.Left), m = l(() => o.position === i.CsTooltip.TooltipPosition.Right), C = l(() => o.position === i.CsTooltip.TooltipPosition.Top), v = l(() => o.position === i.CsTooltip.TooltipPosition.Bottom);
    E(() => {
      var f;
      const c = (f = I()) == null ? void 0 : f.proxy;
      let s = r;
      L(t, (d) => {
        o.showOnHover || (d ? s === r && c && (s = p.subscribe(c.$el, u)) : (p.unsubscribe(s), s = r));
      });
    });
    function u() {
      a.value && o.showOnHover || (t.value = !t.value, t.value ? n("tooltipOpen") : n("tooltipClose"));
    }
    function h() {
      o.showOnHover && (e && clearTimeout(e), t.value = !0, n("tooltipOpen"));
    }
    function w() {
      o.showOnHover && (e = window.setTimeout(() => {
        t.value = !1, n("tooltipClose");
      }, 500));
    }
    function O() {
      o.showOnHover && e && clearTimeout(e);
    }
    return {
      isLeft: T,
      isRight: m,
      isTop: C,
      isBottom: v,
      isVisible: t,
      onClick: u,
      onMouseEnter: h,
      onMouseLeave: w,
      onMouseEnterTooltip: O
    };
  }
});
export {
  g as default
};
